import Repository from "@shared/services/api/abstracts/Repository";
import { UserBasedFavoriteEventSerializer } from "../types/favorite-events";

export default class UserBasedFavoriteEventRepository extends Repository<UserBasedFavoriteEventSerializer> {
  public readonly repositoryName = "UserBasedFavoriteEventRepository";

  public readonly endpoint = "/api/user/tickets/favorites/";
}
